export default {
  HomePage: {
    title: 'Estimator24 — KI-Immobilienbewertung',
    description: 'KI-basierte Bewertung von Wohnungen, Häusern und Wohnanlagen in Europa und der Türkei.'
  },
  AboutPage: {
    title: 'Über Estimator24',
    description: 'Plattform für Immobilienbewertung, Analyse und Investitionen.'
  },
  PropertyList: {
    title: 'Immobilienkatalog — Estimator24',
    description: 'Alle Wohnungen, Villen und Häuser mit KI-Bewertung. Suche nach Land, Region und Entwickler.'
  },
  PropertyDetail: {
    title: '{title} — {city} — Estimator24',
    description: 'Detaillierte Informationen und KI-Bewertung der Immobilie in {city}.'
  },
  DeveloperList: {
    title: 'Entwickler — Estimator24',
    description: 'Verzeichnis der Bauträger und Bauunternehmen.'
  },
  DeveloperDetail: {
    title: '{developer} — Bauträger — Estimator24',
    description: 'Projekte und Wohnanlagen des Entwicklers {developer}.'
  },
  ResidentialComplexShow: {
    title: '{title} — Wohnanlage — Estimator24',
    description: 'Beschreibung, Preise und Grundrisse für {title}.'
  },
  AgencyList: {
    title: 'Immobilienagenturen — Estimator24',
    description: 'Verzeichnis von Immobilienagenturen und ihren Angeboten.'
  },
  AgencyDetail: {
    title: '{agency} — Immobilienagentur — Estimator24',
    description: 'Angebote und Kontaktdaten der Agentur {agency}.'
  },
  NewsList: {
    title: 'Immobiliennachrichten — Estimator24',
    description: 'Statistiken, Analysen und Trends auf dem Immobilienmarkt.'
  },
  NewsDetail: {
    title: '{title} — Estimator24 Nachrichten',
    description: '{excerpt}'
  },
  StatisticPage: {
    title: 'Immobilienstatistik — Estimator24',
    description: 'Daten zu Preisen, Verkäufen und Bauaktivitäten in Echtzeit.'
  },
  PrivacyPolicy: {
    title: 'Datenschutzerklärung — Estimator24',
    description: 'Informationen zur Datenverarbeitung und Datenschutzrichtlinie.'
  }
}
